"use client";

import React from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

interface LottieLoadingProps {
    className?: string;
    size?: number;
    src?: string;
}

export function LottieLoading({
    className,
    size = 300,
    src = "https://lottie.host/0877c327-0194-46c0-9145-0f18bb4d9b7d/cY0MOxRezi.lottie"
}: LottieLoadingProps) {
    return (
        <div className={className} style={{ width: size, height: size }}>
            <DotLottieReact
                src={src}
                autoplay
                loop
            />
        </div>
    );
}
